import axios from "axios";
import { baseURL, generalEndpoint, publicEndpoint } from "../config";

export const Login = async (email, password)=>{
    try{
        const url = `${baseURL}/${publicEndpoint}/Login`;
        const body = {
            "email": email,
            "password": password
        };
        console.log("Sending login request to /api/public/Login: ", email);
        const resp = await axios.post(url, body);
        console.log("RESP => ", resp);
        console.log("RESP DATA => ", resp.data);
        
        if(resp.status === 200){
            const responseData = resp.data;
            console.log("Full response data structure:", JSON.stringify(responseData, null, 2));
            console.log("Response data type:", typeof responseData);
            
            // Handle JWT token response with user data embedded
            if (responseData && responseData.token && typeof responseData.token === 'string') {
                console.log("Received JWT token response:", responseData);
                
                // Extract user data from response (user data is at root level)
                const userData = {
                    id: responseData.userId,
                    email: responseData.email,
                    firstName: responseData.firstName,
                    lastName: responseData.lastName,
                    role: responseData.role,
                    permissions: responseData.permissions || [],
                    permissionCount: responseData.permissions?.length || 0
                };
                
                return {
                    token: responseData.token,
                    user: userData,
                    error: null
                };
            }
            
            // Handle simple string token response
            if (typeof responseData === 'string' && responseData.length > 0) {
                console.log("Received token string:", responseData);
                return {
                    token: responseData,
                    user: { id: responseData }, // Create minimal user object with token as ID
                    error: null
                };
            }
            
            // Handle complex object response (if it comes in the future)
            if (responseData && typeof responseData === 'object') {
                // Check if the response has the expected structure
                if(responseData.isCompletedSuccessfully && responseData.result){
                    // Extract user data from result
                    const userData = responseData.result;
                    console.log("User data extracted: ", userData);
                    
                    const token = userData.id || responseData.id;
                    
                    return {
                        token: token,
                        user: userData,
                        error: null
                    };
                } else if(responseData.result){
                    const userData = responseData.result;
                    const token = userData.id || responseData.id;
                    console.log("Using result data directly:", userData);
                    return {
                        token: token,
                        user: userData,
                        error: null
                    };
                } else if(responseData.id && responseData.email){
                    // Maybe the response is the user data directly
                    console.log("Using response data directly as user data");
                    return {
                        token: responseData.id,
                        user: responseData,
                        error: null
                    };
                }
            }
            
            return {token: null, error: "Login failed - unexpected response format. Response: " + JSON.stringify(responseData)};
        }
        return {token: null, error: resp?.status};

    }catch(ex){
        if(ex?.response){
            console.log(ex?.response?.data);
            return {token: null, error: ex?.response?.data};
        }
        console.log(ex);
        return {token: null, error: ex?.message};
    }
} 
export const Logout = async (username)=>{}

export const GetUser = async (token, email) => {
    try {
        const url = `${baseURL}/${generalEndpoint}/GetUser`;
        const config = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };
        
        console.log("Fetching user data for email:", email);
        const response = await axios.get(`${url}?email=${encodeURIComponent(email)}`, config);
        console.log("User data response:", response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching user data:', error);
        throw error.response?.data || error.message;
    }
};

export const Register = async(email, firstName, lastName, password, confirmPassword)=>{
    try{
        const url = `${baseURL}/${generalEndpoint}/Create`;
        const body = {
            "email": email,
            "firstName": firstName,
            "lastName": lastName,
            "password": password,
            "confirmPassword": confirmPassword
        };
        console.log("Sending register request: ", {email, password});
        const resp = await axios.post(url, body);
        console.log("RESP => ", resp);
        if(resp.status === 200){
            console.log(resp.data);
            return {status: resp.status, message: resp.data, error: null};
        }
        return {status: resp.status, error: resp?.status};

    }catch(ex){
        if(ex?.response){
            console.log(ex?.response?.data);
            return {error: ex?.response?.data};
        }
        console.log(ex);
        return { error: ex?.message};
    }

}